'use client';

import Image from '@/components/image';
// import { banner_event } from '@/utils/gtm';
import { handleLinkByType } from '@/utils/global';
import NextLink from '@/components/next-link';
import { event_select_promotion } from '@/utils/gtm';

const BannerCard = ({ info, isMobile, locale, ref, sliderKey, position }) => {
  const link = handleLinkByType(info?.url, info?.type);
  const src = isMobile
    ? info?.[`mobile-img-${locale}`]
    : info?.[`img-${locale}`];
  return (
    <NextLink
      prefetch={false}
      href={link}
      ref={ref}
      className='overflow-hidden rounded-lg'
      onClick={() =>
        event_select_promotion({
          promotionImage: info?.[`img-${locale}`],
          key: sliderKey,
          position: position,
          id: info?.id,
          name: info?.[`alt-${locale}`],
          url: link,
        })
      }
    >
      <Image
        loading='lazy'
        src={src}
        className='h-auto w-full cursor-pointer rounded-lg transition-all duration-500 hover:scale-105 max-sm:max-h-40 max-sm:min-h-40 md:object-contain'
        alt={info?.[`alt-${locale}`] || 'Banner Img !'}
      />
    </NextLink>
  );
};

export default BannerCard;
